import { render, staticRenderFns } from "./StatementLayout.vue?vue&type=template&id=f6397ab8&scoped=true&"
import script from "./StatementLayout.vue?vue&type=script&lang=js&"
export * from "./StatementLayout.vue?vue&type=script&lang=js&"
import style0 from "./StatementLayout.vue?vue&type=style&index=0&id=f6397ab8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6397ab8",
  null
  
)

component.options.__file = "StatementLayout.vue"
export default component.exports